export default __webpack_public_path__ + "static/media/black-skillit_logo.8347ee6b.svg";